import { useMemo } from 'react';

import { useCurrencyLocale } from '../Provider';
import MoneyFormatter from './MoneyFormatter';
import { MoneyFormatterProps } from './types';

const useMoneyFormatter = ({
  currency,
  rounded,
  styled,
}: MoneyFormatterProps) => {
  const locale = useCurrencyLocale();

  return useMemo(
    () =>
      MoneyFormatter({
        locale,
        currency,
        rounded,
        styled,
      }),
    [locale, currency, rounded, styled]
  );
};

export default useMoneyFormatter;
